<template>
    <ul class="list-unstyled">
        <li class="d-flex align-items-center mb-2"><vue-feather type="user"></vue-feather><span class="fw-bold mx-2 txt-green">Full Name:</span> <span class="text-personal" style="text-transform: capitalize;">{{userStore.user.firstname }} {{userStore.user.lastname}}</span></li>
        <li class="d-flex align-items-center mb-2"><vue-feather type="map"></vue-feather><span class="fw-bold mx-2 txt-green">Address Line 1:</span> <span class="text-personal" style="text-transform: capitalize;">{{userStore.user.address}}</span></li>
        <li class="d-flex align-items-center mb-2"><vue-feather type="map"></vue-feather><span class="fw-bold mx-2 txt-green">Address Line 2:</span> <span class="text-personal" style="text-transform: capitalize;">{{userStore.user.address_line_2}}</span></li>
        <li class="d-flex align-items-center mb-2"><vue-feather type="flag"></vue-feather><span class="fw-bold mx-2 txt-green">City:</span> <span class="text-personal" style="text-transform: capitalize;">{{userStore.user.city}}</span></li>
        <li class="d-flex align-items-center mb-2"><vue-feather type="map-pin"></vue-feather><span class="fw-bold mx-2 txt-green">State:</span> <span class="text-personal" style="text-transform: capitalize;">{{userStore.user.state}}</span></li>
        <li class="d-flex align-items-center mb-2"><vue-feather type="archive"></vue-feather><span class="fw-bold mx-2 txt-green">Zipcode:</span> <span class="text-personal" style="text-transform: capitalize;">{{userStore.user.zipcode}}</span></li>
        <li class="d-flex align-items-center mb-2"><vue-feather type="phone"></vue-feather><span class="fw-bold mx-2 txt-green">Phone:</span> <span class="text-personal">{{userStore.user.phone }}</span></li>
        <li class="d-flex align-items-center mb-2"><vue-feather type="mail"></vue-feather><span class="fw-bold mx-2 txt-green">Email:</span> <span class="text-personal">{{userStore.user.email }}</span></li>
    </ul>
    <div class="col-12 text-center">
        <button class="btn btn-primary mr-1 mt-2" data-toggle="modal" data-target="#client_update_info">Edit
            Client</button>
    </div>
    <contract-download-component></contract-download-component>
    <div class="modal text-left" id="client_update_info" tabindex="-1" role="dialog" aria-labelledby="myModalLabel334"
        aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel334">Edit Client Details</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="model-body">
                    <div class="row mx-auto mt-2">
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <div class="controls">
                                    <label class="txt-green" for="lastname">First Name</label>
                                    <input type="text" class="form-control" required placeholder="First Name" id="firstname"
                                        name="firstname" data-validation-required-message="This firstname field is required"
                                        v-model="userStore.user.firstname" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <div class="controls">
                                    <label class="txt-green" for="middle_name">Middle Name</label>
                                    <input type="text" class="form-control" placeholder="Middle Name" id="middle_name"
                                        name="middle_name" v-model="userStore.user.middle_name" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <div class="controls">
                                    <label class="txt-green" for="lastname">Last Name</label>
                                    <input type="text" class="form-control" required placeholder="Last Name" id="lastname"
                                        name="lastname" data-validation-required-message="This lastname field is required"
                                        v-model="userStore.user.lastname" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group" style="margin-bottom: 0px !important;">
                                <label for="dob">Birth Date</label>
                                <flat-pickr v-model="userStore.user.dob" :config="userStore.config" placeholder="Birth date"
                                    class="form-control" />
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <div class="controls">
                                    <label for="address">Address Line 1</label>
                                    <input type="text" class="form-control" placeholder="Address" id="address"
                                        name="address" data-validation-required-message="This address field is required"
                                        v-model="userStore.user.address" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <div class="controls">
                                    <label for="address_line_2">Address Line 2</label>
                                    <input type="text" class="form-control" placeholder="Address Line 2" id="address_line_2"
                                        name="address_line_2" data-validation-required-message="This address line 2 field is required"
                                        v-model="userStore.user.address_line_2" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <div class="controls">
                                    <label for="city">City</label>
                                    <input type="text" class="form-control" placeholder="City" id="city" name="city"
                                        data-validation-required-message="This city field is required"
                                        v-model="userStore.user.city" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <label for="state">State</label>
                                <v-select v-if="stateStore.states" placeholder="Select State"
                                    v-model="userStore.user.state_id" :options="stateStore.states"
                                    :reduce="state => state.id" />
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <div class="controls">
                                    <label for="zipcode">Zipcode</label>
                                    <input type="text" class="form-control" placeholder="Zipcode" id="zipcode"
                                        name="zipcode" maxlength="5"
                                        data-validation-required-message="This zipcode field is required"
                                        v-model="userStore.user.zipcode" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <div class="controls">
                                    <label for="ssn">SSN
                                        <span class="ml-1">
                                            <a href="#" type="submit" data-toggle="modal" data-target="#ssn_modal">
                                                <strong> (Click Here To Update SSN)</strong>
                                            </a>
                                        </span>
                                    </label>
                                    <input type="text" class="form-control" disabled maxlength="11"
                                        pattern="[0-9]{3}-[0-9]{2}-[0-9]{4}" id="ssn" name="ssn"
                                        :value="mask(userStore.user.ssn, { unmaskedStartDigits: 0, unmaskedEndDigits: 4 })"
                                        data-validation-required-message="This ssn field is required" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <div class="controls">
                                    <label for="phone">Phone</label>
                                    <!-- v-if="userStore.user.phone" -->
                                    <phone-input-component name="phone"
                                        :prop-phone="userStore.user.phone ? userStore.user.phone : null"
                                        @phoneInput="userStore.updatePhoneNumber" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-12">
                            <div class="form-group">
                                <label>E-mail</label>
                                <input type="email" id="email" name="email"
                                    class="form-control border-primary border-darken-1" disabled placeholder="Email"
                                    :value="userStore.user.email" />
                            </div>
                        </div>
                    </div>
                    <div class="col-12 text-center">
                        <button @click="userStore.updateProfile()" class="btn btn-primary mr-1">Save Changes</button>
                        <button type="button" data-dismiss="modal" class="btn btn-outline-primary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useUserStore } from '../../stores/UserStore.js'
    import { useStateStore } from '../../stores/StateStore.js'
    import { mask } from '../../utilities/_helpers'
    import flatPickr from 'vue-flatpickr-component';
    import vSelect from 'vue-select'
    import 'flatpickr/dist/flatpickr.css';
    export default {
        components:{
            flatPickr,
            vSelect,
        },
        mounted() {
        },
        setup() {
            return {
                userStore: useUserStore(),
                stateStore: useStateStore(),
                mask: mask,
                config: {
                    wrap: true,
                    altFormat: 'j-m-Y',
                    altInput: true,
                    dateFormat: 'm-d-Y',
                },
            }
        },
    }
</script>
